module.exports = __webpack_public_path__ + "static/media/worker.5a732bbb.jpg";